import styled from 'styled-components';

import { BasicParagraph } from '../../../../../foundations/typefaces/BasicParagraph';

export const InvisibleText = styled(BasicParagraph)({
  visibility: 'hidden',
});
